import React from 'react';
import { AlertTriangle, DollarSign } from 'lucide-react';
import { Card, CardContent } from '../../../components/ui/card';
import { Badge } from '../../../components/ui/badge';
import { KPICard, formatCurrency } from '../reportShared';

export default function FraudTab({ fraudAlerts }) {
  return (
    <div className="space-y-6" data-testid="reports-fraud-tab">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KPICard title="Total Alerts" value={fraudAlerts.length} icon={AlertTriangle} color="red" />
        <KPICard title="High Severity" value={fraudAlerts.filter(a => a.severity === 'HIGH').length} icon={AlertTriangle} color="red" />
        <KPICard title="Medium Severity" value={fraudAlerts.filter(a => a.severity === 'MEDIUM').length} icon={AlertTriangle} color="amber" />
        <KPICard title="Flagged Amount" value={formatCurrency(fraudAlerts.reduce((s, a) => s + a.total_amount, 0))} icon={DollarSign} color="purple" />
      </div>

      {fraudAlerts.length === 0 ? (
        <Card>
          <CardContent className="py-12 text-center">
            <AlertTriangle className="w-12 h-12 text-green-500 mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-gray-700">No Fraud Alerts</h3>
            <p className="text-gray-500">No suspicious patterns detected in the selected period.</p>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-4">
          {fraudAlerts.map((alert, idx) => (
            <Card key={idx} className={`border-l-4 ${
              alert.severity === 'HIGH' ? 'border-l-red-500' :
              alert.severity === 'MEDIUM' ? 'border-l-amber-500' : 'border-l-blue-500'
            }`}>
              <CardContent className="p-4">
                <div className="flex items-start justify-between">
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <Badge variant={
                        alert.severity === 'HIGH' ? 'destructive' :
                        alert.severity === 'MEDIUM' ? 'warning' : 'secondary'
                      }>
                        {alert.severity}
                      </Badge>
                      <Badge variant="outline">{alert.type.replace('_', ' ')}</Badge>
                    </div>
                    <p className="font-medium text-gray-800">{alert.description}</p>
                    <p className="text-sm text-gray-500 mt-1">
                      Family: {alert.family_id} | Claims: {alert.claim_count} | Amount: {formatCurrency(alert.total_amount)}
                    </p>
                  </div>
                  <AlertTriangle className={`w-6 h-6 ${
                    alert.severity === 'HIGH' ? 'text-red-500' :
                    alert.severity === 'MEDIUM' ? 'text-amber-500' : 'text-blue-500'
                  }`} />
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
